export const CloseIcon = () => (
  <div
    style={{
      transform: 'rotate(45deg)',
      fontFamily: 'math',
      fontSize: 34,
      lineHeight: 1,
      width: 32,
      height: 32,
      marginLeft: 2
    }}
  >
    +
  </div>
);
